import { Component, OnInit, ComponentFactoryResolver, Injector, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { UiEngineComponent } from 'src/modules/base/components/ui-engine/ui-engine.component';
import { PrintService } from 'src/modules/base/shared/services/print.service';
import { TranslateService } from 'src/modules/base/services/translate.service';
import { MessagingService } from 'src/modules/base/shared/services/messaging.service';
import { CommunicationService } from 'src/modules/base/services/communication.service';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { DialogRef } from 'src/modules/base/components/dialog/dialog-ref';

@Component({
    selector: 'app-billingpopup',
    templateUrl: './billingpopup.component.html',
    styleUrls: ['./billingpopup.component.scss'],
    standalone: false
})
export class BillingpopupComponent extends UiEngineComponent implements OnInit {
  resourcedef: any;
  scheme_id: any;
  fieldsform: any;
  addendumdata: any;
  dialogSettleData:any;
  op_popup_data:any;
  addendumfields: any;
  isoptical:boolean = false;
  bill_payer:any;
  args:any;
  is_op_fSixty:boolean = false;
  bill_treating:any;
  scheme_data: any;
  page: any = 0;
  eye_popup:any;
  opt_pop_data:any;
  show_err_message:boolean=false;
  limit: any = 10;
  @Input() action: any;
  show_failed_popup: boolean = false;
  config_opt = {
    "submitButton": true,
    "cancelButton": false,
    "filterForm": false,
    "clearOnSave": true,
    "delegateSave": true,
    "cancelRoute": '',
    "barcode": {
      "isOptical": true,
      "id": "name",
      "datasource": {
        "application": "inventory-management",
        "resource": "stock",
        "query_id": "GET_STOCK_BY_BARCODE",
        "args": "barCode:!!!barCode!!!,location_id:!!!location_id!!!"
      }
    }
  }
  config = {
    "submitButton": true,
    "cancelButton": true,
    "filterForm": false,
    "clearOnSave": false,
    "delegateSave": true,
    "hideSearchBox": true,
    "allowPagination": true,
    "customButtonsAllowed": false,
    "search": false
  }
  configTariff = {
    "submitButton": true,
    "cancelButton": true,
    "filterForm": false,
    "clearOnSave": false,
    "delegateSave": true,
    "cancelRoute": '',
    "allowPagination": true,
    "customButtonsAllowed": false,
    "complex_search": ''
  }
  dialogData: any;
  tarrifData: any;
  searchKey: any;
  filters: any = "";
  treatingDoctorConfig: boolean = false;
  view_count: any;
  pageNameTitle: any;
  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public communicationService: CommunicationService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public messagingService: MessagingService,
    public translateService: TranslateService,
    public printService: PrintService,
    public modal: BsModalService,
    private dialog: DialogRef,
    private dialogConfig: DialogConfig,
    public loader: LoaderService
  ) {
    super(injector, router, route, modal);
    this.initCurrentData();
  }

  ngOnInit() {
    if (this.dialogConfig?.data?.action?.p_for === "payer_failed" || this.dialogConfig?.data?.action?.p_for === "bill_cat_failed") {
      if (this.dialogConfig?.data?.action?.p_for === "payer_failed")
        this.dialogConfig.data['resourceName'] = "billingpayer_details";
      else if (this.dialogConfig?.data?.action?.p_for === "bill_cat_failed")
        this.dialogConfig.data['resourceName'] = "billing_category_tabs";
      this.baseService.getResourceDef("bill_cat_popup", (resouceDef) => {
        if (resouceDef) {
          this.resourcedef = resouceDef;
        }
      })
      this.dialogConfig.data['resource'] = this.dialogConfig.data.item.billing_item_details;
      this.show_failed_popup = true;
      this.dialogData = this.dialogConfig.data;

    }
    if(this.dialogConfig && this.dialogConfig.data && this.dialogConfig.data.form_sixty_screen)
    {
this.is_op_fSixty = true;
this.dialogConfig.data.decorator = this.baseService.initDecorator(this.dialogConfig.data.decorator, this.route, this.injector);
   this.baseService.getResourceDef(this.dialogConfig.data.resource, (resourceDef) => {
      if (resourceDef) {
        this.baseService.getReferredField(resourceDef.form, (fields) => {
          this.eye_popup = { blocks: fields };
        });
      }})
    }
    if(this.route && this.route.snapshot && this.route.snapshot.queryParams && this.route.snapshot.queryParams.returnUrl && this.route.snapshot.queryParams.returnUrl.includes("optical") && this.dialogConfig && this.dialogConfig.data && this.dialogConfig.data.resource && this.dialogConfig.data.resource == "Re_Le_popup")
    {
      this.isoptical = true;
  if(this.dialogConfig.data.refractionData)
    this.opt_pop_data = this.dialogConfig.data.refractionData; 
      else if(this.dialogConfig.data.emr_data)
       this.opt_pop_data = this.dialogConfig.data.emr_data; 
   this.baseService.getResourceDef('Re_Le_popup', (resourceDef) => {
      if (resourceDef) {
        this.baseService.getReferredField(resourceDef.form, (fields) => {
          this.eye_popup = { blocks: fields };
        });
      }})
  }
    if(!this.show_failed_popup && (this.route.snapshot.queryParams.returnUrl && (this.route.snapshot.queryParams.returnUrl.includes("discharge_patientupdate_banner") || this.route.snapshot.queryParams.returnUrl.includes("billingdashboard_format") || this.route.snapshot.queryParams.returnUrl.includes("banner_details_settement"))) && this.action && (this.action.is_scheme || this.action.is_package))
    {
      if (this.action && this.action.is_package == true) {
        this.dialogConfig.data = {
          args: "id:" + this['data'].id,
          resource: 'package_detail',
          action: 'view',
          query_id: 'GET_BY_ID',
          application: 'facility-management'
        }
      }
      else {
        this.scheme_id = this['data'].scheme_id;
        this.dialogConfig.data = {
          args: "id:" + this.scheme_id,
          resource: 'scheme_detail_bill',
          action: 'view',
          query_id: 'GET_BY_ID',
          application: 'facility-management'
        }
      }
    this.op_popup_data = this.dialogConfig;
    this.dialogData = this.dialogConfig.data;
    if (this.dialogData && this.dialogData.action == 'view') {
      let args = this.dialogData.args;
      let resourcee = this.dialogData.resource;
      let query_id = this.dialogData.query_id;
      let application = this.dialogData.application;
      this.baseService.getResourceDef(resourcee, (resouceDef) => {
        if (resouceDef) {
          this._currentData.currentResource = resouceDef.resource;
          this.fieldsform = resouceDef.form;
          if (this.route.snapshot.data.page_name != undefined && this.route.snapshot.data.page_name) {
            this.baseService.setTitleFromResouceDef(this.route.snapshot.data, this.route.snapshot.data.action); // Set Page name,title from route
          } else {
            this.baseService.setTitleFromResouceDef(resouceDef, this.route.snapshot.data.action); // Set Page name,title
          }

          if (resouceDef.layout_type != undefined && resouceDef.layout_type) {
            this._layout = resouceDef.layout_type
          } else {
            this._layout = 'simple';
          }
          if (this._layout == 'simple') {
            this._layout_data = resouceDef;
            // this.initLayoutData();
          } else {
            /*Calling Same code Just 
              layoutRenderer() Have same same code */
            // this.layoutRenderer(resouceDef);
          }
        }
      })
      this.loader.showSpinner();
      this.baseService.get(query_id, args, resourcee, application, "").subscribe((res: any) => {
        if (res) {
          this.loader.hideSpinner();
          this.scheme_data = res.resource[0];
        }
        else
        this.loader.hideSpinner();
      })
    }
  }
  else
  {
    if(!this.show_failed_popup)
    {
    this.op_popup_data=this.dialogConfig;
    if(this.dialogConfig['type'])
    this.dialogSettleData = this.dialogConfig;
    this.dialogData = this.dialogConfig.data;
    if (this.dialogData && this.dialogData.action == 'IMAGE_VIEWER') {
    }
    else if (this.dialogData && this.dialogData.resource == 'tariff_service_item_service_wise') {
      this.baseService.getResourceDef(this.dialogData.viewResource?this.dialogData.viewResource:"facility_detail_tariff_master", (resourceDef) => {
        if (resourceDef) {
          this.resourcedef = resourceDef
          this.configTariff.complex_search = resourceDef.list.complex_search;
          this._currentData.currentFilterListFormFields = {};
          this._currentData.currentFilterListFormFields.blocks = resourceDef;
        }
      });
      if(this.dialogData && this.dialogData.filters != undefined && this.dialogData.filters != ""){
        this.filters = this.dialogData.filters;
      }
      if(this.dialogData && this.dialogData.args != undefined && this.dialogData.args != ""){
        this.args = this.dialogData.args;
      }
      let obj = {
        page_size: 10,
        page_no: this.page,
        filter: this.filters,
        args: this.args ? this.args : ""
      }
      this.loader.showSpinner();
      this.hasTarrif(obj);
    }
    else if (this.dialogData && this.dialogData.action == 'addendum') {
      this.baseService.getResourceDef('addendum_banner', (resouceDef) => {
        if (resouceDef) {
          this.addendumfields = resouceDef;
        }
      })
      this.baseService.get(this.dialogData.query_id, this.dialogData.args, 'addendum_billing_details', 'billing', "").subscribe((res: any) => {
        this.addendumdata = res;
      })
    }
    else if (this.dialogData && this.dialogData.actions == 'noPackage') {
    }
    else if (this.dialogData && this.dialogData.action == 'view') {
      let args = this.dialogData.args;
      let resourcee = this.dialogData.resource;
      let resourcees = this.dialogData.ui_resource;
      let query_id = this.dialogData.query_id;
      let filter = this.dialogData.filter;
      let application = this.dialogData.application;
      if(this.dialogData && this.dialogData.ui_resource && this.dialogData.ui_resource != undefined){
        this.baseService.getResourceDef(resourcees, (resouceDef) => {
          if (resouceDef) {
            this._currentData.currentResource = resouceDef.resource;
            this.resourcedef = resouceDef
            this.fieldsform = resouceDef.form;
            if (this.route.snapshot.data.page_name != undefined && this.route.snapshot.data.page_name) {
              this.baseService.setTitleFromResouceDef(this.route.snapshot.data, this.route.snapshot.data.action); // Set Page name,title from route
              this.pageNameTitle = this.route.snapshot.data
            } else {
              this.baseService.setTitleFromResouceDef(resouceDef, this.route.snapshot.data.action); // Set Page name,title
              this.pageNameTitle = resouceDef
            }
  
            if (resouceDef.layout_type != undefined && resouceDef.layout_type) {
              this._layout = resouceDef.layout_type
            } else {
              this._layout = 'simple';
            }
            if (this._layout == 'simple') {
              this._layout_data = resouceDef;
              // this.initLayoutData();
            } else {
              /*Calling Same code Just 
                layoutRenderer() Have same same code */
              // this.layoutRenderer(resouceDef);
            }
          }
        })
      }
      else{
        this.baseService.getResourceDef(resourcee, (resouceDef) => {
          if (resouceDef) {
            this._currentData.currentResource = resouceDef.resource;
            this.fieldsform = resouceDef.form;
            if (this.route.snapshot.data.page_name != undefined && this.route.snapshot.data.page_name) {
              this.baseService.setTitleFromResouceDef(this.route.snapshot.data, this.route.snapshot.data.action); // Set Page name,title from route
            } else {
              this.baseService.setTitleFromResouceDef(resouceDef, this.route.snapshot.data.action); // Set Page name,title
            }
            if (resouceDef.layout_type != undefined && resouceDef.layout_type) {
              this._layout = resouceDef.layout_type
            } else {
              this._layout = 'simple';
            }
            if (this._layout == 'simple') {
              this._layout_data = resouceDef;
              // this.initLayoutData();
            } else {
              /*Calling Same code Just 
                layoutRenderer() Have same same code */
              // this.layoutRenderer(resouceDef);
            }
          }
        })
      }
      this.baseService.get(query_id, args, resourcee, application, filter).subscribe((res: any) => {
        if (res) {
          this.show_err_message=false;
          this.loader.hideSpinner();
          if(this.dialogData && this.dialogData.ui_resource && this.dialogData.ui_resource != undefined && this.dialogData.grid_required == true){
            this.view_count = res;
          }
          else{
            this.scheme_data = res.resource[0];
          }
          // this.getImage(res.resource[0].package_image_id)
          // this.packageDetail = []
          // const d = { "consultation": res.resource[0]["doctor_consulatation"] }
          // const c = { "diagnostic": res.resource[0]['service_item'] }
          // this.packageDetail.push(d); this.packageDetail.push(c);
          // this.loader.hideSpinner();
        }
        else
        {
        this.loader.hideSpinner();
        this.show_err_message=false;
        }
      })
    }
    else {
      if(this.dialogConfig.data && this.dialogConfig.data.resource && this.dialogConfig.data.resource.length >0){
        this.dialogData.resource = this.dialogConfig.data.resource[0].billing_item_details
        if (!this.parent_id) {
          this.parent_id = 0;
        }
      }
      
      this.treatingDocConfig();
      this.initCurrentData();
      this._currentData.resource = "bill_cat_popup";
      this.baseService.getResourceDef("bill_cat_popup", (resouceDef) => {
        if (resouceDef) {
          this.resourcedef = resouceDef;
          this._currentData.currentListFields = resouceDef.list.fields;
          this._currentData.currentResource = resouceDef.resource;
          if (this.route.snapshot.data.page_name != undefined && this.route.snapshot.data.page_name) {
            this.baseService.setTitleFromResouceDef(this.route.snapshot.data, this.route.snapshot.data.action); // Set Page name,title from route
          } else {
            this.baseService.setTitleFromResouceDef(resouceDef, this.route.snapshot.data.action); // Set Page name,title
          }


        }

      });
      if(this.resourcedef){
      var dataGridConfig = JSON.parse(JSON.stringify(this.resourcedef));
      var dataGridConfig = JSON.parse(JSON.stringify(this.resourcedef.list));
      delete dataGridConfig.filter;
      delete dataGridConfig.fields;
      delete dataGridConfig.bulkAction;
      dataGridConfig.resource = "billing_category_details";
      dataGridConfig.viewAll = true;
      dataGridConfig.hideSearchBox = false;
      dataGridConfig.hideResult = false;
      dataGridConfig.allowPagination = true;
      dataGridConfig.autorefresh = this._currentData != undefined && this._currentData.resouceDef != undefined && this._currentData.resouceDef.config != undefined && this._currentData.resouceDef.config.autorefresh != undefined && this._currentData.resouceDef.config.autorefresh ? this._currentData.resouceDef.config.autorefresh : false;
      this._currentData.dataGridConfig = dataGridConfig;
      this._currentData.dataGridConfig.tile = this._currentData.config.tile;
      this._currentData.dataGridConfig.table = this._currentData.config.table;
    }
  }
  }
}
}
  hasTarrif(obj: any) {
    obj["filter"] = this.filterService.removeDuplicateKeysFromString(obj);
    this.baseService.getData(obj, '', "tariff_service_item", 'facility-management', "GET_PAGE").subscribe((res: any) => {
      this.loader.hideSpinner()
      this.tarrifData = res;
    })
  }

  hasGridData(obj:any,resourcees: any,query_id: any,application: any) {
    this.baseService.getData(obj, '', resourcees, application, query_id).subscribe((res: any) => {
      this.loader.hideSpinner()
      this.view_count = res;
    })
  }

  hide()
  {
    this.dialog.close();
    //this.router.navigateByUrl(this.route.snapshot.queryParams["returnUrl"]);
  }
  treatingDocConfig() {
    this.baseService.get('GET_CONFIG', 'config_code:billing_794,module_code:billing', 'facility_config_mapping', 'facility-management').subscribe(
      result => {
        if (result.errCode == 0) {
          let newresult = result.resource[0]
          if (newresult.config_value == 'true')
            this.treatingDoctorConfig = newresult.config_value;
        }
      });
  }
  onSaveFinishedopt(event)
  {
    if(this.dialogConfig.data.form_sixty_screen)
    {
this.dialog.close(event.result);
    }
    else
    {
    if(this.dialogData && this.dialogData.orderId && this.dialogData.refraction_id)
      this.saveDd(event.result);
this.opt_pop_data = event.result;
this.dialog.close(this.opt_pop_data);
  }
}
  saveDd(e)
  {
    let re = {};
    let le = {};
    for (let k in e) {
      if (k.includes("re_")) {
        let res = k.replace("re_", "");
        re[res] = e[k];
      }
      else if (k.includes("le_")) {
        let res = k.replace("le_", "");
        le[res] = e[k];
      }
    }
    e['re'] = { ...re }
    e['le'] = { ...le }
    let res = {};
    res['re']= e['re'],
    res['le']= e['le']
    res['refraction_id']=this.dialogData.refraction_id;
    res['orderId']=this.dialogData.orderId
    this.baseService.action(res, "UPDATE_REFRACTION", "optical", "opticalOrderDetails").subscribe(data => {
    })

  }
  ngOnDestroy() {
    if (this.modal != undefined) {
      this.modal._hideBackdrop();
      this.modal._hideModal(1);
      this.modal.hide(1);
    }
    if (this.dialogRef && !this.route.snapshot.queryParams.returnUrl.includes("optical"))
      this.dialogRef.close();
    this.hasSubscription.unsubscribe();
  }
  onPageChanged(event: any) {
    this.loader.showSpinner();
    this.page = event - 1;
    let obj = {
      page_size: this.limit,
      page_no: this.page,
      filter: this.filters?this.filters:this.dialogData.filter,
      search_columns: this.searchKey != undefined && this.searchKey != "" ? [this.searchKey.key] : "",
      searchColumns: this.searchKey != undefined && this.searchKey != "" ? this.searchKey.key : "",
      search: this.searchKey != undefined && this.searchKey != "" ? this.searchKey.value : "",
      args: this.args!=undefined && this.args != ""?this.args : this.dialogData.args?this.dialogData.args: ""
    }
    if(this.dialogData && this.dialogData.ui_resource && this.dialogData.ui_resource != undefined && this.dialogData.grid_required == true){
      let application = this.dialogData.application;
      let resourcees = this.dialogData.resource;
      let query_id = this.dialogData.query_id;
      this.hasGridData(obj,resourcees,query_id,application);
    }
    else{
      this.hasTarrif(obj);
    }
  }
  onLimit(event: any) {
    this.loader.showSpinner();
    this.limit = event.target.value;
    this.page = 0;
     let obj = {
      page_size: this.limit,
      page_no: this.page,
      filter: this.filters?this.filters:this.dialogData.filter,
      search_columns: this.searchKey != undefined && this.searchKey != "" ? [this.searchKey.key] : "",
      searchColumns: this.searchKey != undefined && this.searchKey != "" ? this.searchKey.key : "",
      search: this.searchKey != undefined && this.searchKey != "" ? this.searchKey.value : "",
      args: this.args!=undefined && this.args != ""?this.args : this.dialogData.args?this.dialogData.args: ""
    }
    if(this.dialogData && this.dialogData.ui_resource && this.dialogData.ui_resource != undefined && this.dialogData.grid_required == true){
      let application = this.dialogData.application;
      let resourcees = this.dialogData.resource;
      let query_id = this.dialogData.query_id;
      this.hasGridData(obj,resourcees,query_id,application);
    }
    else{
      this.hasTarrif(obj);
    }
  }

  onFilter(event) {
    this.searchKey = event != undefined ? event : this.searchKey;
    this.loader.showSpinner();
    let obj = {
      page_size: this.limit,
      filter: this.filters,
      search_columns: this.searchKey != undefined && this.searchKey != "" ? [this.searchKey.key] : "",
      searchColumns: this.searchKey != undefined && this.searchKey != "" ? this.searchKey.key : "",
      search: this.searchKey != undefined && this.searchKey != "" ? this.searchKey.value : "",
      args: this.args!=undefined && this.args != ""?this.args : ""
    }
    this.hasTarrif(obj);
  }
  onItemSelect(e)
  {
  this.bill_payer = this.op_popup_data.pa.find(val => {
    return val.payer_id == e.target.value;
  });
  }
  ontreatingSelect(e)
  {
    this.bill_treating = this.op_popup_data.da.find(val => {
      return val.treatingDoctorId == e.target.value;
    });

  }
  onSubmit(e)
  {
    if (this.treatingDoctorConfig && this.op_popup_data.isDa && this.op_popup_data.da.length >0 && (this.bill_treating == "" || this.bill_treating == undefined)) {
      this.alerts.error("Treating Doctor Name is Mandatory");
      this.loader.hideSpinner()
      return
    }
    else{
      let data={"payer":this.bill_payer, "treat":this.bill_treating, "treatingDoctorLength": this.op_popup_data.da.length}
      this.smartModalService.sendResult(data);
      this.dialog.close();
    }
    
  }
  bindDataToGrid(event){
    this.loader.showSpinner();
    if (event != undefined && event.includes('tariff_id') && event.includes('serviceType_code')) {
      this.filters = event;
    }
    else if (event != undefined && event.includes('tariff_id') && this.filters != undefined && this.filters.includes('tariff_id')) {
      var formatArray = this.filters.split(',');
      var filterVar = '';
      for( let i=0; i<formatArray.length; i++){
        if(formatArray[i].includes('tariff_id')){
          formatArray[i] = event
        }
        filterVar += formatArray[i]+',';
      }
      this.filters = filterVar.substring(0, filterVar.length - 1)
    }
    else if (event != undefined && event.includes('serviceType_code') && this.filters != undefined && this.filters.includes('serviceType_code')) {
      var formatArray = this.filters.split(',');
      var filtersVar = '';
      for( let i=0; i<formatArray.length; i++){
        if(formatArray[i].includes('serviceType_code')){
          formatArray[i] = event
        }
        filtersVar += formatArray[i]+',';
      }
      this.filters = filtersVar.substring(0, filtersVar.length - 1)
    }
    else{
      this.filters = event != undefined?this.dialogData.filters+','+event:this.dialogData.filters;
    }
    let obj = {
      page_size: this.limit,
      page_no: this.page,
      filter: this.filters,
      search_columns: this.searchKey != undefined && this.searchKey != "" ? [this.searchKey.key] : "",
      searchColumns: this.searchKey != undefined && this.searchKey != "" ? this.searchKey.key : "",
      search: this.searchKey != undefined && this.searchKey != "" ? this.searchKey.value : "",
      args: this.args!=undefined && this.args != ""?this.args : ""
    }
    this.hasTarrif(obj);
  }
}
